<div class="drive-cycle-cont">
  <app-input
    style="flex-grow: 1; cursor: pointer;"
    label="Drive Cycle Name"
    placeholder="Select a drive cycle..."
    [loading]="!partsLoadedEmitted"
    [value]="selectedDCName || ''"
    [type]="InputType.TEXT"
    [readOnly]="true"
    (click)="addDriveCycle()"
  ></app-input>
  <awc-icon [icon]="Icons.INFO_OUTLINE" (click)="addDriveCycle()" id="add-drive-cycle-dialog-btn"></awc-icon>
</div>

<awc-form-select
  label="Aerodynamics"
  placeholder="Aerodynamics..."
  [disabled]="!update && !partsLoadedEmitted"
  [options]="aerodynamics"
  [value]="[selectedAero[0] + '']"
  (valueChange)="selectionIDSet('' + $event?.[0], 'aero_id')"
  [size]="AWCFormElementSize.SMALL">
</awc-form-select>

<awc-form-select
  label="Mass"
  placeholder="Mass..."
  [disabled]="!update && !partsLoadedEmitted"
  [options]="masses"
  [value]="[selectedMass[0] + '']"
  (valueChange)="selectionIDSet('' + $event?.[0], 'mass_id')"
  [size]="AWCFormElementSize.SMALL">
</awc-form-select>

<awc-form-select
  label="Wheel"
  placeholder="Wheel..."
  [disabled]="!update && !partsLoadedEmitted"
  [options]="wheels"
  [value]="[selectedWheel + '']"
  (valueChange)="selectionIDSet('' + $event?.[0], 'wheel_id')"
  [size]="AWCFormElementSize.SMALL">
</awc-form-select>

<awc-form-select
  label="Deceleration Limit"
  placeholder="Optional"
  [disabled]="!update && !partsLoadedEmitted"
  [options]="limits"
  [value]="[selectedLimit[0] + '']"
  [clearAll]="true"
  (valueChange)="selectionIDSet('' + $event?.[0], 'deceleration_limit_id')"
  [size]="AWCFormElementSize.SMALL">
</awc-form-select>

<awc-form-select
  label="Ancillary Load"
  placeholder="Optional"
  [disabled]="!update && !partsLoadedEmitted"
  [options]="loads"
  [value]="[selectedLoad[0] + '']"
  [clearAll]="true"
  (valueChange)="selectionIDSet('' + $event?.[0], 'ancillary_load_id')"
  [size]="AWCFormElementSize.SMALL">
</awc-form-select>
<app-input
  label="Shift Delta"
  placeholder="Shift delta..."
  [disabled]="!update && !partsLoadedEmitted"
  [value]="part.shift_delta"
  [type]="InputTypes.NUMBER"
  [id]="part.id+'_shift_delta'"
  [unit]="UnitType.POWER"
  [updater]="update"
  (update)="setPart.emit([''+$event, 'shift_delta', part.id+'_shift_delta'])"></app-input>
<app-input
  label="Starting State of Charge"
  placeholder="Starting State of Charge..."
  [disabled]="!update && !partsLoadedEmitted"
  [value]="part.starting_state_of_charge"
  [type]="InputTypes.NUMBER"
  [id]="part.id+'_starting_state_of_charge'"
  [unit]="UnitType.RATIO"
  [updater]="update"
  (update)="setPart.emit([''+$event, 'starting_state_of_charge', part.id+'_starting_state_of_charge'])"></app-input>
<app-input
  label="Range"
  placeholder="Optional"
  [disabled]="!update && !partsLoadedEmitted"
  [value]="part.range ?? ''"
  [type]="InputTypes.NUMBER"
  [id]="part.id+'_range'"
  [unit]="UnitType.DISTANCE"
  [updater]="update"
  (update)="setPart.emit([''+$event, 'range', part.id+'_range'])"></app-input>
<app-input
  *featureFlag="FeatureFlagsEnum.FEATURE_THERMAL_MODEL"
  label="Ambient Temperature"
  placeholder="Optional"
  [disabled]="!update && !partsLoadedEmitted"
  [value]="part.ambient_temperature ?? ''"
  [type]="InputTypes.NUMBER"
  [id]="part.id+'_ambient_temperature'"
  [unit]="UnitType.TEMPERATURE"
  [updater]="update"
  (update)="setPart.emit([''+$event, 'ambient_temperature', part.id+'_ambient_temperature'])"></app-input>
<awc-switch
  *featureFlag="FeatureFlagsEnum.FEATURE_THERMAL_MODEL"
  [checked]="!!part.thermal_analysis"
  [label]="'Thermal Analysis'"
  [disabled]="!update && !partsLoadedEmitted"
  [labelPosition]="labelPosition"
  [size]="size"
  [awcSizing]="awcSizing"
  [awcTooltipText]="'Whether component temperatures are modeled during the drive cycle calculation. Enabling this option may increase computation time.'"
  (changes)="toggleThermalAnalysis($event)"></awc-switch>
<awc-switch
  *featureFlag="FeatureFlagsEnum.FEATURE_THERMAL_MODEL"
  [checked]="!!part.stop_at_temperature_limit"
  [label]="'Stop at Temperature Limit'"
  [disabled]="!part.thermal_analysis || (!update && !partsLoadedEmitted)"
  [labelPosition]="labelPosition"
  [size]="size"
  [awcSizing]="awcSizing"
  [awcTooltipText]="'If selected, the drive cycle calculation will stop when any component reaches its temperature limit.'"
  (changes)="toggleStopAtThermalLimit($event)"></awc-switch>

<div>
  <awc-switch
    [checked]="!!part.full_range_calculation"
    [label]="'Full Range Calculation'"
    [disabled]="!update && !partsLoadedEmitted"
    [labelPosition]="labelPosition"
    [size]="size"
    [awcSizing]="awcSizing"
    [awcTooltipText]="'If selected, the drive cycle calculation will repeat until the battery is fully depleted. This may significantly increase computation time.'"
    (changes)="toggleIFullRange($event)"></awc-switch>
</div>
